import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'underscore';
import {getCategories, getCategoriesByIds} from 'reducers/categories.js';
import {fetchTeams} from 'actions/teams.js'
import {fetchCompetitions} from 'actions/competitions.js'
import {fetchCategories, toggleCategory} from 'actions/categories.js';
import {setSidebarEnable} from 'actions/sidebar.js';
import DatabaseService from 'services/DatabaseService.js';
import Utils from 'utils/Utils.js';
import {SET_LOADING_OVERLAY_ENABLE} from 'actions/types';
import jstz from 'jstz';
import moment from 'moment-timezone';
import { getUserRoles } from 'reducers/user.js';
import { fetchSurveys } from 'actions/surveys.js';
import { draftFromSeasonSeasonSurveysMvp, packSeasonSurveysPayloadMvp } from '../seasonQuizMvp.js';

import EditCompetitionModal from './EditCompetitionModal.js';

const Languages = [
    {key:'en',  text:'English (US)',  value:'en'},
    {key:'en_ca',  text:'English (CA)',  value:'en_ca'},
    {key:'fr',  text:'Français', value:'fr'},
];

function sortMilestonesByColumn(milestones, column) {
    if (!Array.isArray(milestones) || !column) return milestones || []
    return [...milestones].sort((a, b) => (Number(a[column] ?? 0) - Number(b[column] ?? 0)))
}

class EditCompetitionModalContainer extends Component {
    constructor(props) {
        super(props);

        var season = this.props.season;

        this.state = {
            busy : true,
            teamsSegments: [],
            addedTeamsSegments: [],
            competitionOptions : [],
            season : season || {},
            categoryToDisplay:null,
            categoryIdList: [],
            uploading: false,
            now: moment().add(1, 'hour').startOf('hour').toDate(),
            preEnrollNow: false,
            startNow: false,
            endNow: false,
            preEnrollmentAtRestore: null,
            startsAtRestore: null,
            endsAtRestore: null,
            dateError: null,
            seasonQuizDraft: [],
            surveySearchQuery: '',
            surveySearchResults: [],
            surveySearchLoading: false,
        };

        this.deleteModalRef = React.createRef();
        this.doSearchDebounced = _.debounce(this.doSearch, 300)
        this.doSurveySearchDebounced = _.debounce(this.doSurveySearch, 300)
        this.onChangeSearch = this.onChangeSearch.bind(this);
        this.onAddSegmentTeam = this.onAddSegmentTeam.bind(this);
    }

    componentDidMount() {
        this.filterCategories()
    }

    componentWillMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.categoriesProp != prevProps.categoriesProp || this.state.competition != prevState.competition) {
            this.filterCategories()
        }
    }

    onRemoveSegmentTeam = (segment) => {
        let addedTeamsSegments = this.state.addedTeamsSegments.filter(e => e.id !== segment.id)
        this.setState({ addedTeamsSegments });
    }

    doSearch() {
        if(this.state.search) {
            this.setState({loadingTeamSegments:true});
            DatabaseService.getTeams({
                    'includeSegments' : 1,
                    'like.name' : this.state.search
                })
                .then(result => {
                    this.setState({teamsSegments:result.teams});
                })
                .catch(error => {
                    window.alert('An error occurred - check logs');
                    console.error(error);
                })
                .then(result => {
                    this.setState({loadingTeamSegments:false});
                });
        } else {
            this.setState({teamsSegments:[]})
        }
    }

    onAddSegmentTeam(segment) {

        this.setState(state=>{
            if(_.findWhere(state.addedTeamsSegments,{id:segment.id})===undefined) {
                return {addedTeamsSegments:[segment].concat(state.addedTeamsSegments),
                        teamsSegments:[],
                        search:''}
            } else {
                return {};
            }
        });

    }

    onChangeSearch(event) {
        var search = event.target.value;
        this.setState({search: search}, this.doSearchDebounced);
    }

    doSurveySearch() {
        var q = (this.state.surveySearchQuery || '').trim();
        if (!q || q.length < 2) {
            this.setState({ surveySearchResults: [], surveySearchLoading: false });
            return;
        }
        this.setState({ surveySearchLoading: true });
        this.props.fetchSurveys({ query: q, queryField: 'title', limit: 20 }, true)
            .then((res) => {
                var results = (res.data || []).map(function (s) {
                    return {
                        key: String(s.id),
                        title: s.title,
                        description: s.tag || '',
                        surveyId: s.id,
                        tag: s.tag,
                    };
                });
                this.setState({ surveySearchResults: results, surveySearchLoading: false });
            })
            .catch((err) => {
                console.error(err);
                this.setState({ surveySearchResults: [], surveySearchLoading: false });
            });
    }

    onSurveySearchChange = (value) => {
        this.setState({ surveySearchQuery: value }, () => this.doSurveySearchDebounced());
    }

    onAddSeasonQuizFromSurvey = (e, { result }) => {
        if (!result || result.surveyId == null) return;
        var surveyId = Number(result.surveyId);
        this.setState(function (state) {
            if (state.seasonQuizDraft.some(function (r) { return Number(r.surveyId) === surveyId; }))
                return {};
            return {
                seasonQuizDraft: state.seasonQuizDraft.concat([{
                    surveyId: surveyId,
                    sortOrder: state.seasonQuizDraft.length,
                    enabled: true,
                    title: result.title,
                    tag: result.tag,
                }]),
                surveySearchResults: [],
                surveySearchQuery: '',
            };
        });
    }

    onRemoveSeasonQuiz = (surveyId) => {
        var id = Number(surveyId);
        this.setState(function (state) {
            return {
                seasonQuizDraft: state.seasonQuizDraft
                    .filter(function (r) { return Number(r.surveyId) !== id; })
                    .map(function (r, i) { return { ...r, sortOrder: i }; }),
            };
        });
    }

    onMoveSeasonQuiz = (surveyId, direction) => {
        var id = Number(surveyId);
        var dir = direction === 'down' ? 1 : -1;
        this.setState(function (state) {
            var list = state.seasonQuizDraft || [];
            var idx = list.findIndex(function (r) { return Number(r.surveyId) === id; });
            if (idx < 0) return {};
            var nextIdx = idx + dir;
            if (nextIdx < 0 || nextIdx >= list.length) return {};
            var next = list.slice();
            var tmp = next[idx];
            next[idx] = next[nextIdx];
            next[nextIdx] = tmp;
            return {
                seasonQuizDraft: next.map(function (r, i) { return { ...r, sortOrder: i }; }),
            };
        });
    }

    challengeCompanyIdsForSeasonSave(season) {
        var sc = season && season.seasonCompanies;
        if (Array.isArray(sc) && sc.length) {
            var ids = [];
            for (var i = 0; i < sc.length; i++) {
                var row = sc[i];
                var cid = row.companyId != null ? Number(row.companyId) : (row.company && row.company.id != null ? Number(row.company.id) : null);
                if (Number.isFinite(cid)) ids.push(cid);
            }
            var uniq = ids.filter(function (v, j, a) { return a.indexOf(v) === j; });
            if (uniq.length) return uniq;
        }
        if (season && Array.isArray(season.companyIds) && season.companyIds.length)
            return season.companyIds.map(Number).filter(function (n) { return Number.isFinite(n); });
        var host = season && season.companyId != null ? Number(season.companyId) : Number(localStorage.companyId);
        return Number.isFinite(host) ? [host] : [];
    }

    filterCategories() {
    if(this.props.categoriesProp) {
            var filteredList = this.state.categoryIdList.map( id => id === null ? {
                id: null,
                title: "(All Enabled Activity Packs)",
                selectable: false,
                companyCategory: {
                    enabled: true
                }
            } : this.props.categoriesProp.find( c => id == c.id ) ).filter( c=> c !== undefined );
            this.setState({categories: filteredList});
        }
    }

    loadData() {
        var _finally = (result) => {

            console.log('finally... -> ')
            console.log(result)


            var season = this.state.season || {};
            let now = moment().add(1,'hour').startOf('hour').toDate();

            if(season.preEnrollmentAt)
                season.preEnrollmentAt = new Date(season.preEnrollmentAt)
            if(season.startsAt)
                season.startsAt = new Date(season.startsAt)
            if(season.endsAt)
                season.endsAt = new Date(season.endsAt)

            if(!season.id) {
                if(!season.preEnrollmentAt)
                    season.preEnrollmentAt = now
                season.startsAt = moment(season.preEnrollmentAt).add(1, 'week').toDate()
                season.endsAt = moment(season.startsAt).add(1, 'week').toDate()
            }

            if(season.startsAt && season.startsAt.getTime() < Date.now() && (!season.endsAt || season.endsAt && season.endsAt.getTime() > Date.now())) {
                season.active = true;
            }

            if(!season.priority)
                season.priority = 0

            this.state.season.hasFeed = !!this.state.season.publicFeedId
            this.state.season.autoStart = !!this.state.season.autoStart
            this.state.season.hasLeaderboard = !!this.state.season.leaderboard?.hidden === false
            this.state.season.hasMilestones = !!this.state.season.seasonMilestones
            this.state.milestones = season.seasonMilestones || [];
            if(season.leaderboard)
                this.state.rewards = season.leaderboard.leaderboardRewards;
            
            if(season.seasonCategories)
                this.state.categoryIdList = _.pluck(season.seasonCategories, "categoryId");
            if(season.seasonCompanyAnnouncements)
                this.state.announcements = season.seasonCompanyAnnouncements;
            if(!this.state.season.timeZone)
                this.state.season.timeZone = (jstz.determine()).name()

            if(!this.state.season.locales) {
                this.state.season.locales = {
                    'en_ca': {
                        enabled : true,
                        locale : 'en_ca',
                        title : moment(season.startsAt).tz(season.timeZone).locale('en-CA').format("MMMM") + " Challenge" 
                    },
                    'en': {
                        enabled : true,
                        locale : 'en',
                        title : moment(season.startsAt).tz(season.timeZone).locale('en').format("MMMM") + " Challenge" 
                    },
                    'fr':{
                        enabled : true,
                        locale : 'fr',
                        title : "Défi de " + moment(season.startsAt).tz(season.timeZone).locale('fr').format("MMMM")
                    }
                }
            }
            
            this.filterCategories()
            this.setState({
                busy: false,
                now: moment().add(1, 'hour').startOf('hour').toDate(),
                preEnrollNow: false,
                startNow: false,
                endNow: false,
                preEnrollmentAtRestore: null,
                startsAtRestore: null,
                endsAtRestore: null,
                dateError: null
            });
        }

        var p1 = this.props.fetchCategories({})

        if(this.state.season.id) {
            /*var p2 = DatabaseService.getCompetition({id : this.state.season.competitionId}).then(result => {
                this.setState({
                    competition: result.competition
                })
            })*/
            var p2 = Promise.all([
                DatabaseService.getSeason({ seasonId: this.state.season.id }),
                DatabaseService.getCompetition({ id: this.state.season.competitionId })
            ]).then(([result1, result2]) => {
                this.setState({
                    season: result1.season,
                    competition: result2.competition,
                    seasonQuizDraft: draftFromSeasonSeasonSurveysMvp(result1.season),
                })
            })
        } else {
            var p2 = DatabaseService.getCompetitions().then((result) => {
                var competitions = result.competitions || [];

                console.log('competitions --> ', competitions)

                for(var i in competitions) {
                    if(competitions[i].competitionRewards) {
                        competitions[i].competitionRewards.sort(function(a, b) { return b.rank ? a.rank - b.rank : -1; })
                    }
                    // if(competitions[i].locales) {
                    //     competitions[i].locales = competitions[i].locales.reduce((a,v) => { a[v.locale] = v; return a}, {})
                    // }
                }
                var state = {
                    competitions : competitions,
                    competitionOptions: competitions.map(function(a, key) { return { key : key, value : a.id, text : a.title } })
                }

                if(this.state.season.competitionId) {
                    state.competition = this.getCompetition(this.state.season.competitionId, competitions)
                }

                this.setState(state);
            })
        }

        // var p3 = DatabaseService.getTeams({}).then(
        //     (result) => { 
        //         var state = {
        //             teams : result.teams
        //         }

        //         this.setState(state);
        //         return result.teams

        //     }, (error) => {   console.error(error) });

        // What's this for?
        // var p4 = DatabaseService.getSegments().then(
        //     (result) => { 
        //         var state = {
        //             segments : result.rows
        //         }

        //         this.setState(state);
        //         return result.rows

        //     }, (error) => { console.error(error) });

        //var p3 = this.props.fetchTeams({})

        return Promise.all([p1, p2/*, p3, p4*/]).catch((error)=> {
            window.alert('An error occurred - check logs');
            console.error(error);
        }).then(_finally,_finally, _finally, _finally);


    }

    getCompetition(competitionId, competitions) {
        competitions = competitions || this.state.competitions;
        var competition = competitions.find(function(a) {return a.id === competitionId});
        if(competition) {
            if(competition.id === this.state.season.competitionId) {
                // fill season customization
            }
            return competition;
        }
    }

    onLanguageInputChange = (event) => {
        var name = event.target.name;
        var value = event.target.value;
        this.setState(Utils.set({...this.state}, name, value))
    }

    onUploadPhoto = () => {
        this.setState({choosePhotoIsOpen:!this.state.choosePhotoIsOpen});
    }

    onConfirmPhoto = (photo) => {
        this.setState(state => {
            let s = {...state};
            Utils.set(s, 'season.leaderboard.banner.dataURL', photo);
            return s;
        });
    }

    // Events

    onSubmit=(event) => {
        event && event.stopPropagation()
        var season = this.state.season
        var preTs = season.preEnrollmentAt ? new Date(season.preEnrollmentAt).getTime() : null
        var startTs = season.startsAt ? new Date(season.startsAt).getTime() : null
        var endTs = season.endsAt ? new Date(season.endsAt).getTime() : null
        if(preTs != null && startTs != null && startTs < preTs) {
            this.setState({ dateError: 'startBeforePreEnroll', uploading: false })
            return
        }
        if(startTs != null && endTs != null && endTs < startTs) {
            this.setState({ dateError: 'endBeforeStart', uploading: false })
            return
        }
        this.setState({ dateError: null, uploading: true })
        var tz = this.state.season.timeZone
        var toTzDate = (d) => moment.tz(moment(d).format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss', tz).toDate()
        var data = {
            competitionId : this.state.competition.id,
            seasonId : season.id,
            season : {
                feed: season.feed,
                locales : Object.values(season.locales).filter(l=>!!season.leaderboard?.locales?.[l.locale]?.title).reduce((agg, v) => { agg[v.locale] = v; return agg }, {}),
                leaderboard: season.leaderboard,
                preEnrollmentAt: toTzDate(season.preEnrollmentAt),
                startsAt: toTzDate(season.startsAt),
                endsAt: toTzDate(season.endsAt),
                timeZone : tz,
                hasFeed: this.state.season.hasFeed,
                autoStart: this.state.season.autoStart,
                hasLeaderboard: this.state.season.hasLeaderboard,
                isSegmented: this.state.season.isSegmented,
                priority: this.state.season.priority
            }
        }

        if (localStorage.master === 'true') {
            var packed = packSeasonSurveysPayloadMvp(this.state.seasonQuizDraft || []);
            data.season.seasonSurveys = packed;
            data.season.companyIds = this.challengeCompanyIdsForSeasonSave(season);
        }

        if(!season.id) {
            if(this.state.season.leaderboard.type !== 'teams') {
                data.season.seasonMilestones = sortMilestonesByColumn(this.state.milestones.filter(a=>a.enabled), this.state.competition?.column);
                
                if(this.state.season.hasLeaderboard)
                    data.season.seasonRewards = this.state.competition.competitionRewards.filter(a=>a.enabled);
            }
            if(this.state.competition.type === 'teams' || this.state.competition.type === 'company') {
                data.season.teamIds = this.state.addedTeamsSegments.map(segment => segment.id);
            }
            
            //teamsCompetition

            data.season.seasonCompanyAnnouncements = this.state.announcements.map(function(a) {
                return {
                    ...a,
                    sendAt : moment.tz(moment(a.sendAt).format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss', data.season.timeZone).toDate()
                }
            });
            data.season.type = this.state.season.leaderboard.type;
        }
        return DatabaseService[season.id ? 'modifySeason' : 'addSeason'](data).then(() => {
            return this.props.fetchCompetitions({}, true)
        }).then(() => {
            this.props.onClose();
        }).catch(() => {
            this.setState({ busy : false, uploading: false });
        });
    }

    onEndCompetition=(event) => {
        // This funky bit of code is used to set the endsAt in such a way that when onSubmit parses it, that it end up being now in the admin's local timezone
        // Get the current now in the Season's timezone, then recreate that same time in the Admin's timezone to set it forward or back in hours between the two zones
        // onSubmit takes that time and converts it back into the seasons local timeZone which brings it back to "now" in the season's timeZone.
        this.state.season.endsAt = moment.tz(moment().tz(this.state.season.timeZone).format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss', (jstz.determine()).name()).toDate(),
        this.onSubmit(event);
    }

    onDelete=(deleteYes) => {
        if(deleteYes){
            //event && event.stopPropagation()
            // don't use busy : true because it hides all the UI
            this.setState({ uploading: true });
            return DatabaseService.removeSeason({seasonId : this.state.season.id}).then(() => {
                return this.props.fetchCompetitions({}, true)
            }, (e) => {
                this.setState({ busy : false, uploading: true });
                return e;
            })
            .then(() => {
                this.props.onClose();
            });
        }
    }

    onToggleCategory = (category) => {
        if(category?.id) {
            this.props.toggleCategory(category.id)
                .catch((error)=> {
                    if(error.code == 1100){
                        window.alert("You cannot add any more activity packs because your organization is already at the limit. You must unsubscribe from other activity packs before you can add this one.");
                    }else {
                        window.alert('An error occurred - check logs');
                    }
                    console.error(error);
                });
        }
    }

    onAddMilestone=(event) => {
        this.setState({
            milestones: [...this.state.milestones, { [this.state.competition.column]: 1, enabled: true }]
        })
    }


    onClickCompetition = (event, value) => {
        if(!this.state.competition || this.state.competition.id !== value) {

            this.setState({busy:true})

            return DatabaseService.getCompetition({id :value}).then(result => {

                let { competition } = result
                //var competition = this.getCompetition(value);
                if(!this.state.season.leaderboard) {
                    this.state.season.leaderboard = {
                        type: competition.type,
                        locales: competition.locales
                    }
                }
                if(this.state.season.locales)
                    Object.values(this.state.season.locales).forEach(l=>{
                        l.title = competition.locales[l.locale]?.subtitle
                        l.description = competition.locales[l.locale]?.description
                    })
                if(this.state.season?.leaderboard?.locales)
                    Object.values(this.state.season.leaderboard.locales).forEach(l=>{
                        l.title = competition.locales[l.locale]?.title
                    })
                if(!this.state.season.feed) {
                    this.state.season.feed = {}
                }
                this.state.season.hasLeaderboard = competition.hasLeaderboard
                this.state.season.feed.allowAssets = competition.allowAssets
                this.state.season.hasFeed = competition.hasFeed
                this.state.season.autoStart = false
                this.state.season.hasMilestones = !!competition.competitionMilestones

                this.setState({
                    season: {...this.state.season},
                    competition : competition,
                    rewards : competition.competitionRewards,
                    milestones : sortMilestonesByColumn(competition.competitionMilestones || [], competition.column),
                    competitionCategories : competition.competitionCategories,
                    announcements : [
                        {
                            type: 1,
                            sendAt : moment(this.state.season.startsAt).add(-7, 'days').startOf('day').hours('12').toDate(),
                            enabled : false
                            //enabled : moment(this.state.season.startsAt).add(-7, 'days').startOf('day').hours('12').toDate().getTime() > Date.now(),
                        },
                        {
                            type: 2,
                            sendAt : moment(this.state.season.startsAt).startOf('day').hours('10').toDate(),
                            enabled : false
                        },
                        {
                            type: 3,
                            sendAt : moment(this.state.season.startsAt).add(7, 'days').startOf('day').hours('10').toDate(),
                            enabled : false
                            //enabled : moment(this.state.season.startsAt).add(7, 'days').startOf('day').hours('10').toDate().getTime() < moment(this.state.season.endsAt).startOf('day').toDate().getTime()
                        },
                        {
                            type: 4,
                            sendAt : moment(this.state.season.endsAt).startOf('day').hours('10').toDate(),
                            enabled : false
                        }
                    ],
                    categoryIdList:_.pluck(competition.competitionCategories, "categoryId"),
                    seasonQuizDraft: [],
                    surveySearchQuery: '',
                    surveySearchResults: [],
                })
                this.filterCategories()
            }).finally(()=>this.setState({busy:false}))
        }
    }

    onClickChange = (event, value) => {
        event && event.stopPropagation()
        this.setState({
            competition : null
        });
    }

    onChangeRankPoints = (e, p, index) => {
        this.setState(Utils.set({...this.state}, index, p.value))
    }

    onChangeCheckbox = (e, p, index) => {
        this.setState(Utils.set({...this.state}, index, p.checked))
    }

    onChangeTeamCheckbox = (e, p, index) => {
        this.setState(Utils.set({...this.state}, index, p.checked))
    }

    onDateChange = (value, index) => {
        this.setState(prev => ({ ...Utils.set({ ...prev }, index, value), dateError: null }))
        if(index == 'season.startsAt' || index == 'season.endsAt') {
            this.setState(Utils.set({...this.state}, 'announcements', [
                {
                    type: 1,
                    sendAt : moment(this.state.season.startsAt).add(-7, 'days').startOf('day').hours('10').toDate(),
                    enabled: false,
                    //enabled : moment(this.state.season.startsAt).add(-7, 'days').startOf('day').hours('10').toDate().getTime() > Date.now()
                },
                {
                    type: 2,
                    sendAt : moment(this.state.season.startsAt).startOf('day').hours('10').toDate(),
                    enabled: false,
                    //enabled : true
                },
                {
                    type: 3,
                    sendAt : moment(this.state.season.startsAt).add(7, 'days').startOf('day').hours('10').toDate(),
                    enabled: false,
                    //enabled : moment(this.state.season.startsAt).add(7, 'days').startOf('day').hours('10').toDate().getTime() < moment(this.state.season.endsAt).startOf('day').toDate().getTime()
                },
                {
                    type: 4,
                    sendAt : moment(this.state.season.endsAt).startOf('day').hours('8').toDate(),
                    enabled: false,
                    //enabled : true
                }
            ]))
        }
    }

    onPreEnrollNowChange = (e, { checked }) => {
        this.setState(prev => ({
            preEnrollNow: !!checked,
            preEnrollmentAtRestore: checked ? prev.season.preEnrollmentAt : prev.preEnrollmentAtRestore,
            season: { ...prev.season, preEnrollmentAt: checked ? new Date() : (prev.preEnrollmentAtRestore != null ? prev.preEnrollmentAtRestore : prev.season.preEnrollmentAt) },
            dateError: null
        }));
    }

    onStartNowChange = (e, { checked }) => {
        this.setState(prev => ({
            startNow: !!checked,
            startsAtRestore: checked ? prev.season.startsAt : prev.startsAtRestore,
            season: { ...prev.season, startsAt: checked ? new Date() : (prev.startsAtRestore != null ? prev.startsAtRestore : prev.season.startsAt) },
            dateError: null
        }));
    }

    onEndNowChange = (e, { checked }) => {
        this.setState(prev => ({
            endNow: !!checked,
            endsAtRestore: checked ? prev.season.endsAt : prev.endsAtRestore,
            season: { ...prev.season, endsAt: checked ? new Date() : (prev.endsAtRestore != null ? prev.endsAtRestore : prev.season.endsAt) },
            dateError: null
        }));
    }

    onTimeZoneChange = (value, index) => {
        //var oldTimeZone = this.state.season.timeZone;
        this.setState(Utils.set({...this.state}, index, value))
        // console.log(moment(this.state.season.startsAt).format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss', this.state.season.timeZone)
        // var startsAt = moment.tz(moment(this.state.season.startsAt).format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss', this.state.season.timeZone);
        // var endsAt = moment.tz(moment(this.state.season.endsAt).format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss', this.state.season.timeZone);
        // console.log( startsAt.format())
        // this.setState(Utils.set({...this.state}, "season.startsAt", startsAt.toDate()))
        // this.setState(Utils.set({...this.state}, "season.endsAt", endsAt.toDate()))
        // this.setState(Utils.set({...this.state}, 'announcements', [
        //     {
        //         type: 1,
        //         sendAt : moment(this.state.season.startsAt).tz(this.state.season.timeZone).add(-7, 'days').startOf('day').hours('10').toDate(),
        //         enabled : moment(this.state.season.startsAt).tz(this.state.season.timeZone).add(-7, 'days').startOf('day').hours('10').toDate().getTime() > Date.now()
        //     },
        //     {
        //         type: 2,
        //         sendAt : moment(this.state.season.startsAt).tz(this.state.season.timeZone).startOf('day').hours('10').toDate(),
        //         enabled : true
        //     },
        //     {
        //         type: 3,
        //         sendAt : moment(this.state.season.startsAt).tz(this.state.season.timeZone).add(7, 'days').startOf('day').hours('10').toDate(),
        //         enabled : moment(this.state.season.startsAt).tz(this.state.season.timeZone).add(7, 'days').startOf('day').hours('10').toDate().getTime() < moment(this.state.season.endsAt).startOf('day').toDate().getTime()
        //     },
        //     {
        //         type: 4,
        //         sendAt : moment(this.state.season.endsAt).tz(this.state.season.timeZone).startOf('day').hours('8').toDate(),
        //         enabled : true
        //     }
        // ]))
    }
    
    onDeleteCompetition = (deleteYes, record) => {
        if(deleteYes) {
            this.setState({busy:true})
            DatabaseService.removeCompetition({competitionId: record.id})
                .catch(error => {
                    window.alert('An error occurred');
                    console.error(error);
                })
                .then(()=>{
                    return this.loadData();
                }).finally(() => {
                    this.setState({busy: false})
                });
        }
    }

    // Render

    render() {
        return (
            <EditCompetitionModal
                {...this.props}
                {...this.state}
                onLanguageInputChange={this.onLanguageInputChange}
                onDateChange={this.onDateChange}
                onSubmit={this.onSubmit}
                onDelete={this.onDelete}
                onClickCompetition={this.onClickCompetition}
                onClickChange={this.onClickChange}
                onEndCompetition={this.onEndCompetition}
                deleteModalRef = {this.deleteModalRef}
                onToggleCategory={this.onToggleCategory}
                onChangeRankPoints={this.onChangeRankPoints}
                onChangeCheckbox={this.onChangeCheckbox}
                onChangeTeamCheckbox={this.onChangeTeamCheckbox}
                onChangeSearch={this.onChangeSearch}
                onTimeZoneChange={this.onTimeZoneChange}
                onPreEnrollNowChange={this.onPreEnrollNowChange}
                onStartNowChange={this.onStartNowChange}
                onEndNowChange={this.onEndNowChange}
                onAddSegmentTeam={this.onAddSegmentTeam}
                onRemoveSegmentTeam={this.onRemoveSegmentTeam}
                languages={Languages}
                onUploadPhoto={this.onUploadPhoto}
                onConfirmPhoto={this.onConfirmPhoto}
                onAddMilestone={this.onAddMilestone}
                onDeleteCompetition={this.onDeleteCompetition}
                seasonQuizDraft={this.state.seasonQuizDraft}
                surveySearchResults={this.state.surveySearchResults}
                surveySearchLoading={this.state.surveySearchLoading}
                surveySearchQuery={this.state.surveySearchQuery}
                onSurveySearchChange={this.onSurveySearchChange}
                onAddSeasonQuizFromSurvey={this.onAddSeasonQuizFromSurvey}
                onRemoveSeasonQuiz={this.onRemoveSeasonQuiz}
                onMoveSeasonQuiz={this.onMoveSeasonQuiz}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        categoriesProp:getCategories(state.categories),
        roles: getUserRoles(state)
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchCategories: (params, force) => dispatch(fetchCategories(params, force)),
        fetchTeams: (params, force) => dispatch(fetchTeams([params, force])),
        toggleCategory: id => dispatch(toggleCategory(id)),
        fetchCompetitions: (params, force) => dispatch(fetchCompetitions(params, force)),
        fetchSurveys: (params, force) => dispatch(fetchSurveys(params, force)),
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation(['competitions', 'categories'])(EditCompetitionModalContainer)));
